import { createContext, useCallback, useContext, useState } from 'react';
import type { WizardStepConfig, WizardStepState } from './types';

type WizardContextState = {
  stepsState: WizardStepState[];
  stepNum: number;
  setStep: (newStep: number) => void;
  currentStep: WizardStepConfig;
  next: () => void;
  prev: () => void;
  totalSteps: number;
};

const WizardContext = createContext<WizardContextState | undefined>(undefined);

export function WizardProvider({
  children,
  steps,
}: {
  children: React.ReactNode;
  steps: WizardStepConfig[];
}) {
  const [stepNum, setStep] = useState(1);
  const currentStep = steps[stepNum - 1];
  const [stepsState, setStepsState] = useState<WizardStepState[]>(
    steps.map((_) => {
      return {
        isSeen: false,
      };
    })
  );

  const next = useCallback(() => {
    setStepsState(
      stepsState.map((_, index) => {
        return {
          isSeen: index <= stepNum,
        };
      })
    );
    setStep(stepNum + 1);
  }, [stepNum]);

  const prev = useCallback(() => {
    setStep(stepNum - 1);
  }, [stepNum]);

  return (
    <WizardContext.Provider
      value={{
        stepsState,
        stepNum,
        setStep,
        currentStep,
        next,
        prev,
        totalSteps: steps.length,
      }}
    >
      {children}
    </WizardContext.Provider>
  );
}

export const useWizardState = (): WizardContextState => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizardState must be used within a WizardStateProvider');
  }
  return context;
};
